const appointmentViewConstants = {
    APPOINTMENT_GET_BY_ID_REQUEST: 'APPOINTMENT_GET_BY_ID_REQUEST',
    APPOINTMENT_GET_BY_ID_SUCCESS: 'APPOINTMENT_GET_BY_ID_SUCCESS',
    APPOINTMENT_GET_BY_ID_FAILURE: 'APPOINTMENT_GET_BY_ID_FAILURE',
    APPOINTMENT_RESET: 'APPOINTMENT_RESET'
};

export default appointmentViewConstants;